export const getStore = state => state.markdown || '';

export const getMonitoredDocumentMarkdown = state => getStore(state).markdown || '';

export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
